import { Outlet } from 'react-router-dom';

function IndexLayout({ children }) {
  return <div className="layout">{children || <Outlet />}</div>;
}

export default IndexLayout;
